export default "__VITE_ASSET__ea1c99c8__"